export const ORIENTATIONS = "/api/all-folders/:param/orientations"
export const ORIENTATION = "/api/all-folders/:param/orientations/:orientationParam"
export const GENERATE_ORIENTATION = "/api/orientations/link_document/:param/generate"
